module.exports = __webpack_public_path__ + "img/Retail15.91fd008f.png";